export default __webpack_public_path__ + "static/media/instagram-logo-white.69bcd74f.svg";